import { Component, OnDestroy, OnInit } from '@angular/core';
import { SelectItem } from '@app/modules/tf-filters';
import { StoreService } from '@app/services/store.service';
import { Subscription } from "rxjs";

@Component({
  selector: 'tf-selected-filters',
  templateUrl: './selected-filters.component.html',
  styleUrls: ['./selected-filters.component.scss']
})
export class TfSelectedFiltersComponent implements OnInit, OnDestroy {
    filters: SelectItem[] = [];
    filtersSubscription: Subscription;

    constructor(public storeService: StoreService) { }

    ngOnInit() {
        this.filtersSubscription = this.storeService.tempFilters$.subscribe((state) => {
            this.filters = this.sort(state.filters);
        });
    }

    ngOnDestroy() {
        this.filtersSubscription.unsubscribe();
    }

    deleteItem(item: SelectItem) {
        this.storeService.removeTempFilter(item);
    }

    deleteAll() {
        this.storeService.resetTempFilters();
    }

    sort(filters: SelectItem[]) {
        return filters.sort((a,b) => a['order'] - b['order']);
    }
}
